module.exports = __webpack_public_path__ + "img/add-dark.157d5f02.svg";